import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import * as moment from 'moment-timezone';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { getFileNameFromUrl, onTimeChange, uploadDocumentImages, phoneNumberLengthValidator, allowOnlyNumbersValidator } from 'src/app/utils/utils.common';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { driverVerificationLabels } from 'src/app/utils/common.utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { addressValidator } from 'src/app/utils/custom-validators';
@UntilDestroy()
@Component({
  selector: 'app-add-driver',
  templateUrl: './add-driver.component.html',
  styleUrls: ['./add-driver.component.css']
})
export class AddDriverComponent implements OnInit {

  driverForm!: FormGroup;
  submitted = false;
  driverId: any;
  companyId: any;
  profileImageURL: any;
  selectedFile: ImageSnippet | null = null;
  verification: any = {};
  rejectionReasons: any = {};
  user:any;
  signatureURL: any;
  signatureModalObj: any;
  
  @Output() onSaveRole = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  @Input() source:any;
  @Input() driver:any;
  @Output() onSaveDriver = new EventEmitter<string>();

  constructor(
    private uploadService: UploadService,
    private cedentialService: CredentialService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService
    
  ) { }

  ngOnInit() {

    this.driverForm = this.fb.group({
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      displayName: [''],
      address: this.fb.group({
        name: ['', Validators.required],
        coords: [[]],
        city: ['', Validators.required],
        state: ['', Validators.required],
      }, { validators: addressValidator() }),
      phoneNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      contactNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      email: ['', [Validators.required, Validators.email]],
      profileImageURL: [''],
      dob: ['', Validators.required],
      languageSpoken: ['', Validators.required],

      driverLicense: this.fb.group({
        image: [''],
        number: ['', Validators.required],
        issueDate: ['', Validators.required],
        expireDate: ['', Validators.required],
        stateIssue: [''],
      }),
      examinations: this.fb.group({
        phyExamImage: [''],
        phyExamDate: [''],
        phyExamExpireDate:[''],
        drugTestImage: [''],
        drugTestDate: [''],
        drugTestExpireDate: [''],
      }),
      abuse: [false],
      violations: [false],
      serviceAreas: [''],
      company: [''],
      isActive: [false],
      signature: [''],
      attestation: ['', Validators.required],
    }, {
      validators: [
        allowOnlyNumbersValidator('phoneNumber'),
        allowOnlyNumbersValidator('contactNumber'),
      ]
    });

    // this.route.params.subscribe((param) => {
    //   this.driverId = param['driverId'];
    //   this.companyId = param['companyId'];
    // });

    if (this.source === 'modal' && this.driver) {
      this.driverId = this.driver.id;
      this.getDriverById();
    } 

    this.getUser();
    // if (this.driverId) {
    //   this.getDriverById();
    // }

  this.validateLinkedDates(this.driverLicense, 'issueDate', 'expireDate');
  this.validateLinkedDates(this.examinations, 'phyExamDate', 'phyExamExpireDate');
  this.validateLinkedDates(this.examinations, 'drugTestDate', 'drugTestExpireDate');
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.companyId = this.user.company.id
      }
    });
  }


  get form() {
    return this.driverForm.controls;
  }

  get addressForm() {
    return this.driverForm.controls.address as FormGroup;
  }

  get driverLicense() {
    return this.driverForm.controls.driverLicense as FormGroup;
  }

  get examinations() {
    return this.driverForm.controls.examinations as FormGroup;
  }

  getDriverById() {
    this.cedentialService.getDriverById(this.driverId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.profileImageURL = data.profileImageURL;
        this.signatureURL = data.signature;
        if(data.validationFlags){
          this.verification = data.validationFlags || {};
        }
        this.rejectionReasons = data.rejectionReasons || {};
        this.driverForm.patchValue({
          ...data,
          driverLicense: {
            ...data.driverLicense,
          },
          examinations: {
            ...data.examinations,
          }

        });
      }
    })
  }


  // profileImage

  processFile(imageInput: any) {
    imageProcessing(imageInput).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          console.error('Invalid file selected.');
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.driverForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl
            }
          },
          error: (uploadError) => {
            console.error('Error uploading image:', uploadError);
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  onSave() {

    this.submitted = true;
    this.driverForm.patchValue({
      company: this.companyId,
    });

    if (this.driverForm.invalid) return;
    
    let payload = this.driverForm.value;

    if (this.driverId) {
      sweetAlert(
        'Confirm Update',
        'Do you want to update and request review, or just update?',
        'question',
        'Update & Request Review',
        'Update'
      ).then((result: any) => {
        if (result.isConfirmed) {
          this.saveDriver(payload, true);
        } else if (result.isDismissed && result.dismiss === 'cancel') {
          this.saveDriver(payload, false);
        }
      });
    } else {
      this.saveDriver(payload, false);
    }
  }

  private saveDriver(payload: any, alsoRequestReview: boolean) {
    this.cedentialService.saveDrivers(this.driverId, payload).pipe(untilDestroyed(this)).subscribe(async (data: any) => {
      if (data) {
        if (alsoRequestReview) {
          await this.sendInvalidFields();
        }
        if (this.source === 'modal') {
            this.onSaveDriver.emit(data);
          }
          else {
        this.router.navigateByUrl(`drivers`);
          }
      }
    },
     (err) => {
           sweetAlert("Error", err, "error", "Ok");
        }
  )
  }

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    console.log('place', place);
    this.driverForm.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null); // Safely calls setValue if formControl is not null
    if (fileInput) {
      fileInput.value = '';
    }
    this.signatureURL = null;
  }

  getTimeRestrictions() {
    return {
      min: null, 
      max: moment().endOf('day').toISOString()
    };
  }

 validateLinkedDates(formGroup: FormGroup, startCtrl: string, endCtrl: string) {
  formGroup.valueChanges.subscribe(values => {
    const start = values[startCtrl];
    const end = values[endCtrl];

    const startControl = formGroup.get(startCtrl);
    const endControl = formGroup.get(endCtrl);

    if (start && end && new Date(start) >= new Date(end)) {
      endControl?.setErrors({ dateMismatch: true });
    } else {
      if (endControl?.hasError('dateMismatch')) {
        endControl.setErrors(null);
      }
    }
  });
}


  // generic Method for upload docuemtns images

  uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null) {
    uploadDocumentImages(documents, formControl, this.uploadService)
  }

   getFileName(url: any) {
      return getFileNameFromUrl(url);
    }

  getRejectionReason(section: string, controlName: string): string {
    return this.rejectionReasons?.[section]?.[controlName]?.reason || '';
  }

  // Generic Datepicker method

  onDateChange(controlName: AbstractControl<any, any> | null) {
  onTimeChange(controlName)
  }

  getInvalidFields(): string[] {
    const formValues = this.verification;
    const labels: string[] = [];
    this.traverseForm(formValues, driverVerificationLabels, labels);
    return labels;
  }

  traverseForm(values: any, labelMap: any, labels: string[], prefix: string = ''): void {
    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'object' && values[key] !== null) {
        // Check if labelMap[key] is an object, recursively call the function
        if (typeof labelMap[key] === 'object') {
          this.traverseForm(values[key], labelMap[key], labels, prefix);
        } else {
          this.traverseForm(values[key], labelMap[key], labels, prefix + labelMap[key] + ' - ');
        }
      } else if (values[key] === false) {
        labels.push(prefix + (labelMap[key] || key));
      }
    });
  }
  
  async sendInvalidFields(): Promise<void> {
    const invalidFields = this.getInvalidFields();

    if (invalidFields.length > 0) {
      try {
        const data = await this.cedentialService.requestReviewDriver(this.driverId, invalidFields).toPromise();
        if (data) {
          console.log("Review request sent successfully.");
          // this.onCloseModal();
        }
      } catch (err) {
        sweetAlert("Error", err, "error", "Ok");
      }
    }
  }

  onChangeDriverOriginAddress() {
     this.driverForm.patchValue({
      address: {
          coords: '',
          city: '',
          state: '',
        }
    });
  }

  openSignatureModal() {
    this.signatureModalObj = { ...this.driverForm.value } || {};
  }
  onCloseSignatureModal(evt: any) {
    if (evt && evt.signature) {
      this.signatureURL = evt.signature;
      this.driverForm.patchValue({ signature: evt.signature });
    }
    this.signatureModalObj = null;
  }
  removeSignature() {
    this.signatureURL = null;
    this.driverForm.patchValue({ signature: '' });
  }
  
}
